import { render, staticRenderFns } from "./CustomArtistDashboard.vue?vue&type=template&id=d7dc843a"
import script from "./CustomArtistDashboard.vue?vue&type=script&lang=js"
export * from "./CustomArtistDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports